import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import './style.css';

function LeftMenuNavigator ({ title, routes }) {
  let { url } = useRouteMatch();
  return (
    <div className="leftMenuContainer">
      <h2>{title}</h2>
      {routes.length && (
        <div className="leftMenu">
        {routes.map(route => {
          return (
            <NavLink
              to={`${url}${route.link}`}
              activeClassName="leftLinkIsActive"
              exact
            >
              {route.title}
            </NavLink>
          )
        })}
      </div>
      )}
    </div> 
  )
}

export default LeftMenuNavigator;